export const getLearnMore = ({ learnMore = 'learnmore', question: { contentTexts = null} = {} }) => {
	if (!contentTexts) return null
	return contentTexts.filter(x => x.tags.includes(learnMore)).pop()
}
